module.exports = __webpack_public_path__ + "img/jobs.4965843e.jpeg";